import roleObj from './global'
export default {
  computed: {
    // 联系人权限下拉列表
    contactRoleDownList () {
      return [
        {
          label: '项目联系人',
          value: this._global.PROJECT_CONTACT
        },
        {
          label: '课题联系人',
          value: this._global.TOPIC_CONTACT
        },
        {
          label: '单位联系人',
          value: this._global.UNIT_CONTACT
        },
        {
          label: '成员',
          value: this._global.MEMBER
        }
      ]
    },
    // 联系人列表
    contactRoleList () {
      return [
        this._global.PROJECT_CONTACT,
        this._global.TOPIC_CONTACT,
        this._global.UNIT_CONTACT,
        this._global.MEMBER
      ]
    },
    // 权限
    role () {
      /*
        { 0： Unknowen ( 需要申请进入课题的用户 ) }
        { 1 ： 总负责人 }
        { 2 ： 课题负责人（主办单位负责人） }
        { 3： 参与单位负责人 }
        { 4： 单位成员 }
      */
      return this.$store.state.baseInfo.role
    },
    // 是否是拥有项目办的身份
    // 默认值为0-否 、 1-是
    isProjectoOffice () {
      return Number(this.$store.state.baseInfo.is_official) === 1
      // return true
    },
    // 是否是项目的负责人或者联系人
    isProjectAdminOrContact () {
      return this.role === this._global.PROJECT_ADMIN || this.role === this._global.PROJECT_CONTACT
    },
    // 是否是课题的负责人或者联系人
    isTopicAdminOrContact () {
      return this.role === this._global.TOPIC_ADMIN || this.role === this._global.TOPIC_CONTACT
    },
    // 是否是单位的负责人或者联系人
    isUnitAdminOrContact () {
      return this.role === this._global.UNIT_ADMIN || this.role === this._global.UNIT_CONTACT
    },
    // 是否是成员
    isMember () {
      return this.role === this._global.MEMBER
    },
    // 项目负责人 >= 单位联系人 的权限
    isProjectAdminToUnitContact () {
      return this.role >= this._global.PROJECT_ADMIN && this.role <= this._global.UNIT_CONTACT
    }
  },
  filters: {
    roleFilter (role) {
      let roleName = ''
      switch (role) {
        case roleObj.PROJECT_ADMIN:
          roleName = '总负责人'
          break
        case roleObj.PROJECT_CONTACT:
          roleName = '项目联系人'
          break
        case roleObj.TOPIC_ADMIN:
          roleName = '课题负责人'
          break
        case roleObj.TOPIC_CONTACT:
          roleName = '课题联系人'
          break
        case roleObj.UNIT_ADMIN:
          roleName = '单位负责人'
          break
        case roleObj.UNIT_CONTACT:
          roleName = '单位联系人'
          break
        case roleObj.MEMBER:
          roleName = '单位成员'
          break
      }
      return roleName
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/role-mixin.js